import { Icon } from "../../assets";
import { DataLinksProps } from "./App.types";
import { SelectorTypes } from "./components/Selector/Selector.types";

export function getLinks(links: DataLinksProps): SelectorTypes.Props[] {
 return [
  {
   id: "recipes_web",
   title: "Recetario web",
   text: "Accede a nuestra web de recetas.",
   icon: Icon.Cutlery,
   link: links.linkRecipesWeb || "",
  },
  {
   id: "recipes_robot",
   title: "Recetas",
   text: "Ver catálogo de vídeos de recetas.",
   icon: Icon.Recipes,
   link: links.linkRecipesRobot || "",
  },
  {
   id: "instagram",
   title: "Redes sociales",
   text: "Accede a nuestro instagram.",
   icon: Icon.Instagram,
   link: links.linkInstagram || "",
  },
  {
   id: "manuals",
   title: "Manuales",
   text: "Ver manuales.",
   icon: Icon.Manual,
   link: links.linkManuals || "",
  },
  {
   id: "maintenance_guide",
   title: "Guía de mantenimiento",
   text: "Como limpiar tu producto.",
   icon: Icon.Clean,
   link: links.linkMaintenanceGuide || "",
  },
  {
   id: "support",
   title: "Soporte CecoCare",
   text: "Un link, todas las soluciones",
   icon: Icon.StandbyOff,
   link: links.linkCecotecSupport || "",
  },
 ];
}
